import produce from "immer";
import { StudentReportActions } from ".";
import { IStoreState } from "../initialStoreState";
import { defaultStudentReport, defaultStudentReportState } from "./deafult";
import { CLEAR_STUDENT_REPORT, CLEAR_STUDENT_REPORT_STATE, FETCH_STUDENT_REPORT_DETAIL_LIST_FAILED, FETCH_STUDENT_REPORT_DETAIL_LIST_PROGRESS, FETCH_STUDENT_REPORT_DETAIL_LIST_SUCCESS, FETCH_STUDENT_REPORT_LIST_FAILED, FETCH_STUDENT_REPORT_LIST_PROGRESS, FETCH_STUDENT_REPORT_LIST_SUCCESS } from "./studentReportAction";
import { LoadState } from "../../constants/enums";


export const studentReportReducer = (
  state: IStoreState["studentReport"] = defaultStudentReportState,
  action: StudentReportActions
) => {
    switch (action.type) {
        case FETCH_STUDENT_REPORT_LIST_PROGRESS: {
             const newState = produce(state, (draftState) => {
               draftState.studentReport.loading = LoadState.InProgress;
               draftState.list.data = [];
               draftState.studentReport.data = defaultStudentReport;
               draftState.list.totalRecords = 0;
               
               
             });
             return newState;
           }
           case FETCH_STUDENT_REPORT_LIST_SUCCESS: {
             const { data, totalFeeAmount, totalPaidFee, pendingFee } = action.payload;
             const newState = produce(state, (draftState) => {
               draftState.studentReport.loading = LoadState.Loaded;
             
               draftState.list.data = data;
            
               draftState.amount.totalFeeAmount = totalFeeAmount;
               draftState.amount.totalPaidFee = totalPaidFee;
               draftState.amount.pendingFee = pendingFee;
              
             });
             return newState;
           }
           case FETCH_STUDENT_REPORT_LIST_FAILED: {
             const newState = produce(state, (draftState) => {
               draftState.studentReport.loading = LoadState.Failed;
               draftState.list.data = [];
               draftState.studentReport.data = defaultStudentReport;
               draftState.list.totalRecords = 0;
              


             });
             return newState;
           }
           case FETCH_STUDENT_REPORT_DETAIL_LIST_PROGRESS: {
            const newState = produce(state, (draftState) => {
              draftState.studentReport.loading = LoadState.InProgress;
              draftState.list.data = [];
              draftState.studentReport.data = defaultStudentReport;
              draftState.list.totalRecords = 0;
            });
            return newState;
           }  
          //  case FETCH_STUDENT_REPORT_DETAIL_LIST_SUCCESS: {
          //   const { data, totalRecords,  totalFeeAmount, totalPaidFee, pendingFee } = action.payload;
          //   const newState = produce(state, (draftState) => {
          //     draftState.studentReport.loading = LoadState.Loaded;
          //     draftState.list.data = data;
          //     draftState.amount.totalFeeAmount = totalFeeAmount;
          //     draftState.amount.totalPaidFee = totalPaidFee;
          //     draftState.amount.pendingFee = pendingFee;
          //     draftState.list.totalRecords = totalRecords;
          //   });
          //   return newState;
          //  }
           case FETCH_STUDENT_REPORT_DETAIL_LIST_FAILED: {
            const newState = produce(state, (draftState) => {
              draftState.studentReport.loading = LoadState.Failed;
              draftState.list.data = [];
              draftState.studentReport.data = defaultStudentReport;
            });
            return newState;
           }  
           case CLEAR_STUDENT_REPORT_STATE: {
            return defaultStudentReportState;
           }
        
           default: {
            return state;
          }
      }
    
};
